export default __webpack_public_path__ + "static/media/nodon512.ddd74f11.png";